import React from "react";
import PartnerSection from "../components/PartnerSection";
import { Files, Workflow, Bot, MessagesSquare, Target, ClipboardCheck, FileCheck2, ShieldCheck, Accessibility } from "lucide-react";
import "../App.css";

import i18next from "../i18n";

const crawtech_logo = require("../images/partners/crawtech-logo.png");
const IBM_logo = require("../images/partners/IBM.png");
const OpenText_logo = require("../images/partners/OpenText_gold.png");
import { Helmet } from "react-helmet-async";

function Partners() {
  return (
    <div className="partners">
      <Helmet>
        <title>Partners</title>
        <meta
          name="description"
          content={i18next.t("pages.partners.summary.description")}
        />
        <link rel="canonical" href="https://xperconsulting.no/partnere" />
      </Helmet>
      <div className="bg-main">
        <div className="container max-w-xl py-36 justify-start items-start text-white">
          <div className="w-full md:w-3/5 text-left text-xl ">

            <h1 className="text-5xl font-bold text-white mb-6">
              {i18next.t("pages.partners.technology-partners.h1")}
            </h1>
            <p>{i18next.t("pages.partners.technology-partners.p-1")}</p>
            <p>{i18next.t("pages.partners.technology-partners.p-2")}</p>

            <p>{i18next.t("pages.partners.technology-partners.p-3")}</p>
            <ul className="list-disc list-outside ml-6">
              <li>{i18next.t("pages.partners.technology-partners.ul-li-1")}</li>
              <li>{i18next.t("pages.partners.technology-partners.ul-li-2")}</li>
              <li>{i18next.t("pages.partners.technology-partners.ul-li-3")}</li>
            </ul>
          </div>
        </div>
      </div>

      <section className="bg-gray px-5 py-16 md:px-6 md:py-24">
        <div className="mx-auto max-w-2xl">
          <div className="mx-auto max-w-lg text-left">
            <h2 className="mb-5 text-3xl font-bold leading-tight tracking-[-0.03em] text-main-dark md:text-5xl">
              {i18next.t("pages.partners.summary.title")}
            </h2>
            <p className="mb-10 text-lg leading-relaxed text-main-dark/75 md:mb-14 md:text-xl">
              {i18next.t("pages.partners.summary.description")}
            </p>
          </div>
          <div className="grid gap-5 md:grid-cols-3 md:gap-6">
            {[
              {
                logo: IBM_logo,
                alt: "IBM",
                key: "ibm",
                logoClassName: "w-52 md:w-56",
                cardClassName: "bg-[#344459] text-white md:translate-y-5 motion-safe:md:hover:translate-y-4",
                logoAreaClassName: "bg-[#dce8f0]",
              },
              {
                logo: OpenText_logo,
                alt: "OpenText Gold Partner Reseller",
                key: "openText",
                logoClassName: "w-64",
                cardClassName: "bg-[#fffaf3] text-main-dark",
                logoAreaClassName: "bg-[#f2e5d5]",
              },
              {
                logo: crawtech_logo,
                alt: "Crawford Technologies",
                key: "crawford",
                logoClassName: "w-64",
                cardClassName: "bg-[#2d5961] text-white md:translate-y-3 motion-safe:md:hover:translate-y-2",
                logoAreaClassName: "bg-[#dcece8]",
              },
            ].map(({ logo, alt, key, logoClassName, cardClassName, logoAreaClassName }) => (
              <a
                href={`#partner-${key}-title`}
                className={`block overflow-hidden rounded-2xl transition-transform duration-200 motion-safe:hover:-translate-y-1 motion-reduce:transition-none focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-4 focus-visible:outline-main ${cardClassName}`}
                key={key}
              >
                <div className={`flex h-48 items-center justify-center px-8 md:h-52 ${logoAreaClassName}`}>
                  <img className={`max-h-28 object-contain ${logoClassName}`} src={logo} alt={alt} />
                </div>
                <p className="mb-0 min-h-[10rem] p-7 text-xl font-medium leading-relaxed md:p-8">
                  {i18next.t(`pages.partners.summary.${key}.focus`)}
                </p>
              </a>
            ))}
          </div>
        </div>
      </section>

      <PartnerSection partnerKey="ibm" logo={IBM_logo} name="IBM" icons={[Files, Workflow, Bot]} />
      <PartnerSection partnerKey="openText" logo={OpenText_logo} name="OpenText Gold Partner Reseller" icons={[MessagesSquare, Target, ClipboardCheck]} warm />
      <PartnerSection partnerKey="crawford" logo={crawtech_logo} name="Crawford Technologies" icons={[FileCheck2, ShieldCheck, Accessibility]} />
    </div>
  );
}

export default Partners;
